import { routes } from 'app/routing/routesConfig';

export const isDetailsPage = (pathname: string, guid?: string) => {
  const detailsPagePathname = guid
    ? routes.songDetails.path.replace(':guid', guid)
    : routes.songDetails.path;

  return detailsPagePathname === pathname;
};

export const isAudioPage = (pathname: string, guid?: string) => {
  const detailsPagePathname = guid
    ? routes.songAudioList.path.replace(':guid', guid)
    : routes.songAudioList.path;

  return detailsPagePathname === pathname;
};

export const isLyricsPage = (pathname: string, guid?: string) => {
  const lyricsPagePathname = guid
    ? routes.songLyrics.path.replace(':guid', guid)
    : routes.songLyrics.path;

  return lyricsPagePathname === pathname;
};

export const getReleaseGuidFromReleaseCallback = (pathname: string | null) => {
  const pattern = /releases\/([^/]+)/;

  const match = pathname?.match(pattern);
  if (match) {
    return match[1];
  }
  return match?.[1];
};
